/**
 * Open a returned game URL inside the app iframe route (/iframeURL).
 */
export function openGameInIframe(router, store, url, meta = {}) {
  if (url == null || url === '') return;

  store.commit('setIframeGame', {
    url,
    gameName: meta.gameName || meta.name || '',
    provider: meta.provider || '',
    backRoute: meta.backRoute || '/home',
  });

  router.push('/iframeURL').catch(() => {});
}
